import { translate } from '~l10n/client';
import { toast } from '~shared/components/Toast';
import { TeacherApplicationContext } from '~shared/context/TeacherApplicationContext';
import { ReportUrls } from '~shared/utils/urlBuilders/ReportsUrlBuilder';

import { pollForDownloadReady } from '../../../util/ReportDownload';
import axios from '../../localAxios';

function downloadQuizApi(
  body,
  shouldAutoPoll = true,
  appContext: TeacherApplicationContext = TeacherApplicationContext.Socrative,
  onPollComplete?: (url: string) => void
) {
  const url = new ReportUrls().downloadEmptyQuizUrl();
  return axios
    .post(url, body)
    .then((response) => {
      const data = response['data'];

      if (shouldAutoPoll) {
        toast(translate('Your download will begin shortly'), {
          duration: 2500,
        });
        pollForDownloadReady({
          pollingUrl: data['url'],
          appContext,
          onPollComplete: onPollComplete,
        });
      } else {
        // Return data for caller to handle polling
        return data;
      }
    })
    .catch((error) => {
      console.error(error);
      toast(translate('An unknown error occurred. Please try again later.'), {
        tone: 'critical',
      });
      throw error;
    });
}

export function downloadEmptyWorkspaceQuiz(
  quizId: string,
  workspaceId: string,
  appContext?: TeacherApplicationContext,
  onPollComplete?: (url: string) => void
) {
  return downloadQuizApi(
    {
      workspace_data: { workspace_id: workspaceId, workspace_quiz_id: quizId },
    },
    true,
    appContext,
    onPollComplete
  );
}

export async function downloadEmptyQuiz(
  quizId: number,
  appContext?: TeacherApplicationContext,
  onPollComplete?: (url: string) => void
) {
  return downloadQuizApi({ quiz_id: quizId }, true, appContext, onPollComplete);
}

export async function downloadAnswerKey(quizId: number, options?: any) {
  return downloadQuizApi(
    {
      quiz_id: quizId,
      options: options || {
        include_explanations: false,
        include_correct_answers: true,
      },
    },
    false // Don't auto-poll, return data for caller to handle
  );
}

export function downloadWorkspaceAnswerKey(
  quizId: string,
  workspaceId: string,
  options?: any
) {
  return downloadQuizApi(
    {
      workspace_data: { workspace_id: workspaceId, workspace_quiz_id: quizId },
      options: options || {
        include_explanations: false,
        include_correct_answers: true,
      },
    },
    false // Don't auto-poll, return data for caller to handle
  );
}
